<template lang="pug">
tr(class='cursor-pointer hover:bg-gray-lightest' @click='goToOrder')
  td(class='w-full max-w-0 py-4 pl-4 pr-3 text-sm font-bold sm:w-auto sm:max-w-none sm:pl-6')
    | {{ item.orderNumber }}
    dl(class='lg:hidden')
      dt(class='sr-only') Description
      dd(class='mt-1 font-normal flex')
        InlineHtml(:text='item.desc' class='truncate')
        span(
          v-if='badgeItemCount'
          class='ml-2 bg-gray-lighter text-gray-600 group-hover:bg-gray-200 inline-block py-0.5 px-3 text-xs rounded-full'
        ) +{{ badgeItemCount }}

      dt(class='sr-only md:hidden') Date
      dd(class='mt-1 font-normal truncate md:hidden')
        | {{ orderDate }}

      dt(class='sr-only sm:hidden') Status
      dd(class='mt-1 font-normal truncate sm:hidden')
        OrderStatus(:status='item.status' :show-dot='true')

  td(class='hidden px-3 py-4 text-sm md:table-cell')
    | {{ orderDate }}

  td(class='hidden px-3 py-4 text-sm lg:table-cell')
    dl
      dd(class='flex')
        InlineHtml(:text='item.desc')
        span(
          v-if='badgeItemCount'
          class='ml-2 bg-gray-lighter text-gray-600 group-hover:bg-gray-200 inline-block py-0.5 px-3 text-xs rounded-full'
        ) +{{ badgeItemCount }}

  td(class='hidden px-3 py-4 text-sm sm:table-cell')
    OrderStatus(:status='item.status' :show-dot='true')

  td(class='py-4 pr-4 pl-3 text-sm text-right') ${{ item.grandTotal }}

  td(class='py-4 pr-4 pl-3 text-sm text-right')
    ChevronRightIcon(class='ml-auto w-4 h-4 stroke-current')
</template>

<script>
import ChevronRightIcon from '@/assets/chevronRight.svg?component'

export default defineNuxtComponent({
  name: 'OrderItem',
  components: {
    ChevronRightIcon,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    orderDate() {
      return new Date(this.item.created).toLocaleDateString()
    },
    badgeItemCount() {
      return this.item.itemCount - 1
    },
  },
  methods: {
    goToOrder() {
      navigateTo({
        name: 'order-status-orderId',
        params: { orderId: this.item.id },
        query: { token: this.item.token },
      })
    },
  },
})
</script>
